import { FormProvider, useForm } from 'react-hook-form';
import css from './subscription-form.module.scss';
import { useEffect, useId, useRef } from 'react';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import * as yup from 'yup';
import * as v from 'src/utils/form/validate';
import { yupResolver } from '@hookform/resolvers/yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { env } from 'src/constants/env';
import API from 'src/components/subscribe/api';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';

interface Props {
  showText?: boolean;
  onSubmit: (email: string) => void;
}

function SubscriptionForm({ showText = true, onSubmit }: Readonly<Props>) {
  const captchaRef = useRef<ReCAPTCHA>(null);
  const methods = useForm({
    mode: 'onBlur',
    resolver: yupResolver(
      yup.object({
        email: v.validateEmail(yup, true)
      })
    ),
    defaultValues: {
      email: ''
    }
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitSuccessful, isDirty, isValid }
  } = methods;

  const emailId = useId();

  const onFormSubmit = async (data: { email: string; captcha: string }) => {
    if (data?.email && data.email.length > 0) {
      try {
        await API.subscribeToUpdates({ ...data, status: 1 }).then((response: { id: string }) => {
          response?.id && onSubmit(data.email);
        });
      } catch (error) {
        toast(`${(error as AxiosError)?.response?.data}`);
        onSubmit(data.email);
      }
    }
  };

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset();
      captchaRef.current?.reset();
    }
  }, [isSubmitSuccessful, reset]);

  return (
    <div className={css.subscription}>
      {showText && (
        <>
          <h3>Підписуйся на оновлення</h3>
          <p>Підписуйтесь на оновлення платформи, щоб бути в курсі наших останніх оновлень та поповнень каталогу</p>
        </>
      )}
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(async (data) => {
            const token = await captchaRef.current?.executeAsync();
            data.email && token && onFormSubmit({ email: data.email, captcha: token });
          })}>
          <div className={css.emailInput}>
            <input id={emailId} type='text' placeholder='Ваш email' {...register('email')} className={css.input} />
            <button disabled={!isDirty || !isValid}>
              <LinkArrow />
            </button>
          </div>
        </form>
        <ReCAPTCHA
          ref={captchaRef}
          className={css.captcha}
          sitekey={env.REACT_APP_NZ_RECAPTCHA_SITE_KEY}
          hl='uk'
          size='invisible'
        />
      </FormProvider>
    </div>
  );
}

export default SubscriptionForm;
